import { Layout, Row, Col } from 'antd';

import CopyRight from '../CopyRight';

function Footer() {
  const { Footer: AntFooter } = Layout;

  return (
    <AntFooter>
      <Row className="just">
        <Col xs={24} md={12} lg={12}>
          <CopyRight />
        </Col>
      </Row>
    </AntFooter>
  );
}

export default Footer;
